import { dataOnce } from "../../main/data/data";
export function updateEditInput(e) {
    const target = e.target;
    if (target.classList.contains("cp-edit-urls__select")) {
        dataOnce(`active/${target.value}`).then((data) => {
            document.querySelector(".cp-edit-urls__url").value = decodeURI(decodeURIComponent(data.url));
        });
    }
}
